const appVersion = process.env.REACT_APP_APP_VERSION || '0.1.0';
const buildSha = process.env.REACT_APP_BUILD_SHA || 'development';
const buildTime = process.env.REACT_APP_BUILD_TIME || null;
const buildRef = process.env.REACT_APP_BUILD_REF || 'local';
const imageTag = process.env.REACT_APP_IMAGE_TAG || 'local';

export const frontendBuildInfo = {
  appVersion,
  buildSha,
  buildShaShort: buildSha === 'development' ? 'dev' : buildSha.slice(0, 7),
  buildTime,
  buildRef,
  imageTag,
};

export function formatBuildTimestamp(isoString) {
  if (!isoString) {
    return 'Not recorded';
  }

  try {
    return new Date(isoString).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch {
    return isoString;
  }
}
